import { createSlice } from "@reduxjs/toolkit";
import { Search } from "utilities/svg";

const initialState = {
  search: "",
  distributor: [],
  company: "",
  CartSource: "MOVP",
  Count: 50,
  SkipCount: 0,
  isMappedSearch: null,
  IsStock: 2,
  IsScheme: 2,
  IsSort: 1,
  SearchMode: 0,
  therapyName: "",
};

const productSearchSlice = createSlice({
  name: "productSearch",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setDistributor: (state, action) => {
      state.distributor = action.payload;
    },
    setCompany: (state, action) => {
      state.company = action.payload;
    },
    setCartSource: (state, action) => {
      state.CartSource = action.payload;
    },
    setCount: (state, action) => {
      state.Count = action.payload;
    },
    setSkipCount: (state, action) => {
      state.SkipCount = action.payload;
    },
    setisMappedSearch: (state, action) => {
      state.isMappedSearch = action.payload;
    },
    setIsStock: (state, action) => {
      state.IsStock = action.payload;
    },
    setIsScheme: (state, action) => {
      state.IsScheme = action.payload;
    },
    setIsSort: (state, action) => {
      state.IsSort = action.payload;
    },
    setSearchMode: (state, action) => {
      state.SearchMode = action.payload;
    },
    setFilter: (state, action) => {
      state.IsStock = action.payload?.IsStock ?? 2;
      state.IsScheme = action.payload?.IsScheme ?? 2;
      state.IsSort = action.payload?.IsSort ?? 1;
      state.SearchMode = action.payload?.SearchMode ?? 1;
    },
    setTherapy: (state, action) => {
      state.therapyName = action.payload;
    },
    clearSearch: (state) => {
      state.search = "";
      // state.distributor = [];
      state.company = "";
      state.CartSource = "MOVP";
      state.Count = 50;
      state.SkipCount = 0;
      state.isMappedSearch = null;
      state.IsStock = 2;
      state.IsScheme = 2;
      state.IsSort = 1;
      state.SearchMode = 0;
      state.therapyName = "";
    },
    cleardist: (state) => {
      state.distributor = []
    },
    clearFilter: (state) => {
      state.IsStock = 2;
      state.IsScheme = 2;
      state.IsSort = 1;
      state.SearchMode = 0;
    },
  },
});

export const {
  setSearch,
  setTherapy,
  setDistributor,
  setCompany,
  setCartSource,
  setCount,
  setSkipCount,
  setisMappedSearch,
  setIsStock,
  setIsScheme,
  setIsSort,
  setSearchMode,
  clearSearch,
  clearFilter,
  cleardist,
  setFilter
} = productSearchSlice.actions;

export default productSearchSlice.reducer;
